import { render, staticRenderFns } from "./SISStudentMedical.vue?vue&type=template&id=08b86b68&scoped=true&"
import script from "./SISStudentMedical.vue?vue&type=script&lang=js&"
export * from "./SISStudentMedical.vue?vue&type=script&lang=js&"
import style0 from "./SISStudentMedical.vue?vue&type=style&index=0&id=08b86b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b86b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b86b68')) {
      api.createRecord('08b86b68', component.options)
    } else {
      api.reload('08b86b68', component.options)
    }
    module.hot.accept("./SISStudentMedical.vue?vue&type=template&id=08b86b68&scoped=true&", function () {
      api.rerender('08b86b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/Widgets/SISStudentMedical.vue"
export default component.exports